// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"910c060e","488":"756a9772"}[chunkId] + ".chunk.js";
};